import request from '@/utils/request'
// 北向资金：板块列表
export function bklist(query) {
    return request({
        url: '/Integration/getBanKuaiTj',
        method: 'get',
        params: query
    })
}


// 北向资金：机构列表
export function jgList(query) {
    return request({
        url: '/Integration/getHolderRanking',
        method: 'get',
        params: query
    })
}